import { render, staticRenderFns } from "./thisWeekBarChart.vue?vue&type=template&id=4b40ab88&scoped=true"
import script from "./thisWeekBarChart.vue?vue&type=script&lang=js"
export * from "./thisWeekBarChart.vue?vue&type=script&lang=js"
import style0 from "./thisWeekBarChart.vue?vue&type=style&index=0&id=4b40ab88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40ab88",
  null
  
)

export default component.exports